import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);
}

export function formatNumber(num, decimals = 2) {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals
  }).format(num);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function formatDateTime(dateString) {
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function truncateAddress(address, chars = 4) {
  if (!address) return '';
  return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`;
}

export function getStatusColor(status) {
  const colors = {
    pending: 'text-yellow-500 bg-yellow-500/10',
    active: 'text-blue-500 bg-blue-500/10',
    funded: 'text-green-500 bg-green-500/10',
    repaid: 'text-emerald-500 bg-emerald-500/10',
    defaulted: 'text-red-500 bg-red-500/10',
    accepted: 'text-green-500 bg-green-500/10',
    rejected: 'text-red-500 bg-red-500/10',
    withdrawn: 'text-gray-500 bg-gray-500/10'
  };
  return colors[status?.toLowerCase()] || 'text-gray-500 bg-gray-500/10';
}

export function getRiskColor(riskLevel) {
  const colors = {
    'Low': 'text-green-500',
    'Medium': 'text-yellow-500',
    'High': 'text-orange-500',
    'Very High': 'text-red-500'
  };
  return colors[riskLevel] || 'text-gray-500';
}
